import { render } from "./KpiCardV2.vue?vue&type=template&id=60398fd7&scoped=true"
import script from "./KpiCardV2.vue?vue&type=script&lang=js"
export * from "./KpiCardV2.vue?vue&type=script&lang=js"

import "./KpiCardV2.vue?vue&type=style&index=0&id=60398fd7&lang=scss&scoped=true"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60398fd7"]])

export default __exports__